import moment from 'moment';
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';

export default function getHeaderForDateTimeHourFormat(
  columnData: Header,
  maxVal?: number
) {
  return {
    accessorKey: columnData.parent.parent_field,
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order,

    cell: (info) => moment(info.getValue()).format('Do MMM YY, h:mm A'),
    meta: {
      className: 'last text-column'
    },
    header: () => (
      <Grid container alignItems='center' flexDirection='column'>
        <Grid
          item
          xs='auto'
          container
          alignItems='center'
          className='change-text'
        >
          <Grid item sx={{ cursor: 'pointer' }}>
            {columnData.parent.alias}
            {getHeaderName(columnData)}
          </Grid>
        </Grid>
      </Grid>
    )
  };
}
